import { render } from "./UploadDocuments.vue?vue&type=template&id=3148b914&ts=true"
import script from "./UploadDocuments.vue?vue&type=script&lang=ts"
export * from "./UploadDocuments.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Github\\guardsonlinesms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__